export default "__VITE_ASSET__B3B5XzDr__"